import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { mapObjectKeysToCamelCase } from '@/utils/object-mapper-utils';

export const purchaseApi = createApi({
  reducerPath: 'purchaseApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getAdminPurchaseRequestList: builder.query<
      ApiResponse<any>,
      {
        filter: string;
        page: number;
        pageSize?: number;
        email?: string;
        brokerId?:string;
        dateRange?: [string, string];
      }
    >({
      query: ({ filter, page, email, brokerId, dateRange, pageSize = 10 }) => {
        return {
          url: `v1/online-assessment/purchase/list`,
          method: 'GET',
          params: {
            filter,
            page: page,
            pageSize,
            ...(email && { email }),
            ...(brokerId && {brokerId}),
            ...(dateRange && {
              startDate: dateRange[0],
              endDate: dateRange[1],
            }),
          },
        };
      },
    }),
    getPurchaseStepsData: builder.query<ApiResponse<any>, { id: string }>({
      query: ({ id }) => {
        return {
          url: `v1/online-assessment/purchase/step-data/${id}`,
          method: 'GET',
        };
      },
    }),
    getApplicationStepData: builder.query<any, { id: number; step: string }>({
      query: ({ id, step }) => {
        return {
          url: `v1/online-assessment/purchase/step-data/${id}/${step}`,
          method: 'GET',
        };
      },
      transformResponse: (response: any) => {
        return mapObjectKeysToCamelCase(response?.data?.data);
      },
    }),

  }),
});

export const {
  useGetAdminPurchaseRequestListQuery,
  useGetPurchaseStepsDataQuery,
  useGetApplicationStepDataQuery
} = purchaseApi;
